/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import { ITextProps, Text } from '@fluentui/react/lib/Text';
import * as React from 'react';
import { getStylist } from 'src/core/themes/luisStylist';
import { PrebuiltEntityMetadata } from 'src/luis/projects/entities/types/PrebuiltEntityMetadata';

const { styleComponent } = getStylist('PrebuiltEntityRow');

const PrebuiltEntityName = styleComponent<ITextProps>(Text)('', theme => ({
    fontWeight: theme.nameFontWeight as any
}));

/**
 * This simple component renders prebuilt entity information in a stack
 * format with the name a little more prominent than the rest of the info.
 */
export const PrebuiltEntityRow = (props: PrebuiltEntityMetadata) => {
    const { name, description, examples } = props;

    return (
        <Stack tokens={{ childrenGap: 10 }}>
            <PrebuiltEntityName variant="mediumPlus">{name}</PrebuiltEntityName>
            <Text variant="small">{description}</Text>
            <Text variant="small">{examples}</Text>
        </Stack>
    );
};
